module.exports = __webpack_public_path__ + "img/lasource-11.eaee6439.jpg";